import { RotateCw, Copy, Trash2, ListPlus } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { SHAPE_TYPES, DIM_LABELS } from "./shapes";

export const ShapeProperties = ({ shape, onChange, onDelete, onDuplicate, onAddLineItem }) => {
  if (!shape)
    return <div data-testid="shape-properties-empty" className="p-5 text-sm text-zinc-500">Select a shape on the canvas to edit its dimensions, or add one from the toolbar.</div>;
  const setDim = (k, v) => onChange({ ...shape, dims: { ...shape.dims, [k]: Math.max(0, Number(v) || 0) } });
  return (
    <div data-testid="shape-properties" className="space-y-4 p-5">
      <div>
        <div className="eyebrow">Selected</div>
        <div className="font-display text-xl font-bold uppercase">{SHAPE_TYPES[shape.type].label}</div>
      </div>
      <div>
        <Label className="text-xs text-zinc-500">Label</Label>
        <Input data-testid="shape-label-input" value={shape.label} placeholder="e.g. Waste line A" onChange={(e) => onChange({ ...shape, label: e.target.value })} />
      </div>
      {Object.keys(shape.dims).map((k) => (
        <div key={k}>
          <Label className="text-xs text-zinc-500">{DIM_LABELS[k]}</Label>
          <Input data-testid={`shape-dim-${k}`} type="number" min={0} className="font-mono" value={shape.dims[k]} onChange={(e) => setDim(k, e.target.value)} />
        </div>
      ))}
      <div>
        <Label className="text-xs text-zinc-500">Rotation (°)</Label>
        <div className="flex gap-2">
          <Input data-testid="shape-rotation-input" type="number" className="font-mono" value={shape.rotation} onChange={(e) => onChange({ ...shape, rotation: Number(e.target.value) || 0 })} />
          <Button data-testid="shape-rotate-90" variant="outline" size="icon" onClick={() => onChange({ ...shape, rotation: (shape.rotation + 90) % 360 })}><RotateCw className="h-4 w-4" /></Button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 pt-2">
        <Button data-testid="shape-duplicate" variant="outline" size="sm" onClick={onDuplicate}><Copy className="mr-1 h-4 w-4" />Duplicate</Button>
        <Button data-testid="shape-delete" variant="outline" size="sm" className="text-red-600 hover:text-red-700" onClick={onDelete}><Trash2 className="mr-1 h-4 w-4" />Delete</Button>
      </div>
      <Button data-testid="shape-add-line-item" className="w-full bg-zinc-900 hover:bg-zinc-800" onClick={onAddLineItem}><ListPlus className="mr-2 h-4 w-4" />Add as line item</Button>
    </div>
  );
};
